import { render, staticRenderFns } from "./LongtailSetting.vue?vue&type=template&id=a5b5fca6&scoped=true&"
import script from "./LongtailSetting.vue?vue&type=script&lang=js&"
export * from "./LongtailSetting.vue?vue&type=script&lang=js&"
import style0 from "./LongtailSetting.vue?vue&type=style&index=0&id=a5b5fca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b5fca6",
  null
  
)

export default component.exports